import { isPublicRoute } from './public/public-routes';

/**
 * Entry point. Public pages (the SMS opt-in form) and the authenticated application are bootstrapped
 * by separate modules, loaded dynamically so that neither pulls in the other: importing the Fondation
 * shell on the consent page would start the auth flow and redirect a parent to a login screen they
 * have no account for.
 */
if (isPublicRoute(window.location.pathname)) {
  void import('./public/public-main').then(({ mountPublicApp }) => mountPublicApp());
} else {
  void import('./app-main').then(({ mountApp }) => mountApp());
}
